import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {of} from 'rxjs/observable/of';
import {catchError, tap} from 'rxjs/operators';
import {ErrorObservable} from 'rxjs/observable/ErrorObservable';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable()
export class CoreService {

  public buName: string = "Module d'inscription Orange";

  constructor(private http: HttpClient) {

  }

  /**
   * Get events informations of BU
   *
   * @param buSlug  | string
   * @return object
   */
  getEvents(buSlug): Observable<any> {
    const url = '/api/events/' + buSlug;
    return this.http.get(url, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Get event informations
   *
   * @param eventSlug  | string
   * @return object Event Information
   */
  getEvent(eventSlug): Observable<any> {
    const url = '/api/event/' + eventSlug;
    return this.http.get(url, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  getSearchResult(buSlug, obj): Observable<any> {
    console.log("🚀 ~ file: core.service.ts ~ line 77 ~ CoreService ~ getSearchResult ~ obj", obj)
    const url = '/api/events/' + buSlug + '/search?query='+obj.params.query;
    return this.http.post(url, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Get event informations By Slot ID
   *
   * @param idSlot | string
   * @return object Event Informations
   */
  getSlot(idSlot): Observable<any> {
    const url = '/api/slot/' + idSlot;
    return this.http.get(url, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Subscribe to an event
   */
  subscribeToEvent(idSlot, obj): Observable<any> {
    const url = '/api/slot/' + idSlot + '/subscribe';
    return this.http.post(url, obj, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Unsubscribe to an event
   */
  unsubscribeToEvent(idSlot, obj): Observable<any> {
    const url = '/api/slot/' + idSlot + '/unsubscribe';
    return this.http.post(url, obj, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Share a slot
   */
  shareASlot(idSlot, obj): Observable<any> {
    const url = '/api/slot/' + idSlot + '/share';
    return this.http.post(url, obj, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  /**
   * Share an event
   */
  shareAnEvent(slugEvent, obj): Observable<any> {
    const url = '/api/event/' + slugEvent + '/share';
    return this.http.post(url, obj, httpOptions).pipe(
      catchError(this.handleError)
    );
  }


  /**
   * get data parcours volontaire
   */
  getOpenToVolunteersEvent(): Observable<any> {
    const url = '/api/open-to-volunteers';
    return this.http.get(url, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * send datas parcours volontaire
   */
  sendDataVoluntary(data): Observable<any> {
    const url = '/api/volunteer';
    return this.http.post(url, data, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * get legal notices data
   */
  getLegalNotices(): Observable<any> {
    const url = '/api/legal-notices';
    return this.http.get(url, httpOptions).pipe(
      catchError(this.handleError)
    );
  }


  sendFormHelp(data): Observable<any> {
    const url = '/api/contact';
    return this.http.post(url, data, httpOptions).pipe(
      catchError(this.handleError)
    );
  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   */
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
      return new ErrorObservable(error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${error.status},body was:`);
      console.error(error)
    }

    let errorMsg: string = "";
    if (error.status == 500) {
      errorMsg = "Une erreur est survenue. Veuillez réessayer ultérieurement";
    }
    else {
      errorMsg = error.error.message;
    }

    return new ErrorObservable(errorMsg);
  };

  /**
   * Check if we are in a iframe
   */
  inIframe():boolean {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/helper/core/core.service.ts